/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: callFlowsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteCallFlow } from './api/callFlowApi';

/**
 * Shared helpers for Call Flows module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Call Flow in the form.
 * Pattern: /pbx/incoming-tools/call-flows/new?duplicate={id}
 */
export const getCallFlowDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/call-flows/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Call Flow id.
 */
export const navigateToCallFlowDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getCallFlowDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Call Flow by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteCallFlowById = async (id: string | number): Promise<void> => {
  await deleteCallFlow(id);
};

